import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from '@tanstack/react-router';
import { createApplicationRouter } from './router.js';
import { createSessionGateway } from './session/session.js';
import './styles/global.css';

const container = document.getElementById('root');
if (container === null) {
  throw new Error('Root container #root is missing from index.html');
}

const gateway = createSessionGateway();
const root = createRoot(container);

/**
 * The session is read once, before the first render.
 *
 * Rendering the shell and then discovering the session would flash an
 * authenticated layout at someone who is not authenticated, which is both a
 * defect and a disclosure — the navigation it flashes is entitlement-filtered.
 */
const session = await gateway.load();
const router = createApplicationRouter({ session, gateway });

root.render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
);
